import { WidgetProps } from '@rjsf/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { hooks as commonHooks } from '@sitebuilder/common';

const Orientation = (props: WidgetProps) => {
    const { label, value, onChange } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        onChange(e.target?.value);
    };

    const i18n = commonHooks.useLocalization();

    return (
        <div className="orientation-widget">
            <label>{label}</label>
            <label>
                <input
                    type="radio"
                    id="portrait"
                    className="orientation-radio-input"
                    value="portrait"
                    checked={value === 'portrait'}
                    onChange={handleChange}
                />
                <FontAwesomeIcon
                    id={'portrait-icon'}
                    className={`icon ${value === 'portrait' ? 'selected' : ''}`}
                    icon={faUser}
                    title={i18n.t('customSchemaWidgets_portrait')}
                />
            </label>
            <label>
                <input
                    type="radio"
                    id="landscape"
                    className="orientation-radio-input"
                    value="landscape"
                    checked={value === 'landscape'}
                    onChange={handleChange}
                />
                <FontAwesomeIcon
                    id={'landscape-icon'}
                    className={`icon fa-rotate-270 ${value === 'landscape' ? 'selected' : ''}`}
                    icon={faUser}
                    title={i18n.t('customSchemaWidgets_landscape')}
                />
            </label>
        </div>
    );
};

export default Orientation;
